import { useTranslation } from 'react-i18next';

import {
    AlertDialog,
    AlertDialogAction,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogHeader,
    AlertDialogTitle,
} from '@codes/ui-kit/components/ui/alert-dialog';
import { Loader2 } from 'lucide-react';

interface CodesKeyDeleteDialogProps {
    open: boolean;
    onOpenChange: (open: boolean) => void;
    keyName: string;
    isDeleting: boolean;
    onConfirm: () => void;
}

export const CodesKeyDeleteDialog = ({
    open,
    onOpenChange,
    keyName,
    isDeleting,
    onConfirm,
}: CodesKeyDeleteDialogProps) => {
    const { t } = useTranslation();

    return (
        <AlertDialog open={open} onOpenChange={onOpenChange}>
            <AlertDialogContent>
                <AlertDialogHeader>
                    <AlertDialogTitle>{t('codesKeys.deleteDialog.title')}</AlertDialogTitle>
                    <AlertDialogDescription>
                        {t('codesKeys.deleteDialog.description', { name: keyName })}
                    </AlertDialogDescription>
                </AlertDialogHeader>
                <AlertDialogFooter>
                    <AlertDialogCancel disabled={isDeleting}>{t('codesKeys.deleteDialog.cancel')}</AlertDialogCancel>
                    <AlertDialogAction
                        className="bg-destructive text-destructive-foreground hover:bg-destructive/90"
                        onClick={onConfirm}
                        disabled={isDeleting}
                    >
                        {isDeleting ? (
                            <>
                                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                {t('codesKeys.deleteDialog.deleting')}
                            </>
                        ) : (
                            t('codesKeys.deleteDialog.confirm')
                        )}
                    </AlertDialogAction>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    );
};
